import { Component, Input, OnChanges } from '@angular/core';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';

@Component({
  selector: 'np-table-referral-converted',
  templateUrl: './referral-converted.component.html',
  styleUrls: ['./referral-converted.component.scss']
})
export class TableReferralConvertedComponent implements OnChanges {
  @Input()
  filter: any;

  public rows = [];
  public columns = [
      {
        title: 'Month',
        name: 'month',
        sort: 'asc',
        width: '200px'
      },
      {
        title: 'Conversion ratio',
        name: 'conversionRatio',
        width: '200px'
      },
      {
        title: 'Average time to conversion',
        name: 'averageTimeToConversion',
        width: '180px'
      }
    ];
  constructor(private tableService: TableService) { }

  ngOnChanges() {
    this.getTableData();
  }

  public getTableData() {
    this.tableService.getTableConvertedAccountData().subscribe(
      data => {
        this.rows = data || [];
      },
    );
  }
}
